import { useState } from "react";

import Modal from "../../../layouts/Modal";
import StatusPill, { StatusPillColour } from "../../shared/StatusPill";
import Tooltip from "../../shared/Tooltip";
import { IOfferUpdateBatchItemStatus, OfferUpdateType } from "../../../models/OfferUpdate";

const typeLabel: Record<number, string> = {
  [OfferUpdateType.BestOfferReset]: "Reset",
  [OfferUpdateType.Title]: "Title",
  [OfferUpdateType.Policy]: "Policies",
  [OfferUpdateType.Description]: "Description",
  [OfferUpdateType.ConditionDescription]: "Condition",
  [OfferUpdateType.Images]: "Images",
};

export default function OfferUpdateStatusCell({ status }: { status?: IOfferUpdateBatchItemStatus }) {
  const [modalOpen, setModalOpen] = useState(false);

  if (!status) {
    return null;
  }

  if (status.status === "Pending") {
    return <StatusPill text="Queued" colour={StatusPillColour.Neutral} />;
  }

  if (status.status === "Processing") {
    return <StatusPill text="Updating…" colour={StatusPillColour.Purple} />;
  }

  if (status.status === "Success") {
    const label = typeLabel[status.type] ?? "Updated";
    const title =
      status.type === OfferUpdateType.BestOfferReset && status.newAutoAcceptPrice != null
        ? `New auto-accept £${status.newAutoAcceptPrice.toFixed(2)}`
        : `${label} updated`;

    return (
      <span title={title}>
        <StatusPill text={label} colour={StatusPillColour.Green} />
      </span>
    );
  }

  const failLabel = typeLabel[status.type] ?? "Update";

  return (
    <>
      <Tooltip content={`${failLabel} failed — click for full error`}>
        <button
          type="button"
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            setModalOpen(true);
          }}
        >
          <StatusPill text="Failed" colour={StatusPillColour.Red} />
        </button>
      </Tooltip>

      <Modal open={modalOpen} setOpen={setModalOpen} width="max-w-[70vw]">
        <div className="p-4">
          <h3 className="mb-4 text-lg font-semibold">eBay Update — Error</h3>
          <div className="max-h-[70vh] overflow-y-auto">
            <pre className="overflow-x-auto whitespace-pre-wrap break-words rounded border bg-gray-50 p-4 text-sm">
              {status.errorMessage}
            </pre>
          </div>
        </div>
      </Modal>
    </>
  );
}
